import React from "react";
import { TrainingCenterBundleItemVideoMediaOverlay } from "../../../system/AppState/AppStateTrainingCenter";
import { List } from "../../../utils/List";
import { TrainingCenterLanguagePreference } from "../TrainingCenterLanguageLookup";
import TrainingCenterVideoMediaOverlayWrapper from "./TrainingCenterVideoMediaOverlayWrapper";

interface Props {
  playedSeconds: number;
  mediaOverlays: List<TrainingCenterBundleItemVideoMediaOverlay>;
  languagePreference: TrainingCenterLanguagePreference;
}

const TrainingCenterVideoMediaOverlays = (props: Props) => {
  const [images, setImages] = React.useState<Map<string, HTMLImageElement>>();

  React.useEffect(() => {
    const imageObjects = new Map<string, HTMLImageElement>();
    props.mediaOverlays.map((overlay) => {
      overlay.overlayData.map((langData) => {
        if (langData.data.imageUrl !== undefined) {
          const image = new Image();
          image.src = langData.data.imageUrl;
          image.onload = () => {
            imageObjects.set(image.src, image);
            setImages(imageObjects);
          };
        }
      });
    });
  }, [props.mediaOverlays]);

  return (
    <div className="TrainingCenterVideoMediaOverlaysWrapper">
      <div className="TrainingCenterVideoMediaOverlays">
        {props.mediaOverlays.zipWithIndex().map(([mediaOverlay, index]) => (
          <TrainingCenterVideoMediaOverlayWrapper
            key={index}
            currentSecond={props.playedSeconds}
            mediaOverlay={mediaOverlay}
            languagePreference={props.languagePreference}
            images={images}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(TrainingCenterVideoMediaOverlays);
